import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SalesHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "SalesHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "m28.694 16.708-3.553 3.46.843 4.896a4.17 4.17 0 0 1-1.666 4.126 4.17 4.17 0 0 1-4.438.317l-4.401-2.32-4.402 2.32a4.2 4.2 0 0 1-4.438-.317 4.19 4.19 0 0 1-1.67-4.126l.63-3.632a3.21 3.21 0 0 1-1.462-2.695c0-1.779 1.441-3.225 3.22-3.225s3.226 1.446 3.226 3.225a3.22 3.22 0 0 1-2.69 3.174l-.614 3.554c-.125.717.15 1.404.739 1.831a1.83 1.83 0 0 0 1.967.14l4.948-2.606a1.16 1.16 0 0 1 1.093 0l4.942 2.607c.628.34 1.398.286 1.971-.14a1.83 1.83 0 0 0 .74-1.832l-.952-5.504c-.069-.38.062-.77.337-1.042l3.99-3.886a1.84 1.84 0 0 0 .475-1.914 1.86 1.86 0 0 0-1.525-1.286l-5.52-.806a1.18 1.18 0 0 1-.884-.64l-2.462-5.01a1.84 1.84 0 0 0-1.68-1.034c-.73 0-1.358.385-1.68 1.04l-2.462 5.005c-.172.343-.5.582-.885.64l-7.053 1.035a1.17 1.17 0 0 1-.34-2.315L9.486 8.8l2.19-4.458A4.19 4.19 0 0 1 15.46 2c1.605-.01 3.074.9 3.78 2.342L21.43 8.8l4.918.718a4.21 4.21 0 0 1 3.407 2.878 4.2 4.2 0 0 1-1.061 4.312"
    })
  }));
};
SalesHubIcon.displayName = 'SalesHubIcon';